export function backendBase(value) {
  return (value || "").trim().replace(/\/+$/, "");
}

export function resolveFileUrl(pathOrUrl, backend = "") {
  if (!pathOrUrl) return null;
  if (/^(https?:\/\/|blob:|data:image\/)/i.test(pathOrUrl)) return pathOrUrl;
  const base = backendBase(backend);
  if (pathOrUrl.startsWith("/api/")) return `${base}${pathOrUrl}`;
  return `${base}/api/files/${pathOrUrl.replace(/^\/+/, "")}`;
}
